const InputStyles = {
  textField: {
    '& .MuiInputBase-root': {
      background: '#F5F5F5',
      boxShadow:
        '-5px 5px 10px 0px rgba(174, 174, 192, 0.2),4px -4px 15px 0px rgba(255, 255, 255, 1)',
      borderRadius: '16px',
    },
    '& .MuiOutlinedInput-root:hover': {
      '& > fieldset': {
        border: '1px solid #FFFFFF',
      },
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '1px solid #FFFFFF',
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #FFFFFF',
      },
    },
    '& .MuiInputBase-root.Mui-disabled': {
      border: '1px solid none !important',
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #FFFFFF',
      },
    },
  },
  errMessage: {
    display: 'flex',

    fontSize: '12px !important',
    fontWeight: 'bold',
    textAlign: 'right !important',
    color: 'var(--red)',
    marginTop:'6px',
    marginRight:'8px'
  },
  InputAdornmentText: {
    color: '#707070',
    fontWeight: '400',
    fontSize: '14px',
    marginLeft: '15px',
  },

  inputBox: {
    '& input': {
      textAlign: 'center',
      color: '#753CBE',
      fontFamily: 'dana-bold',
      fontSize: '14px',

      height: '15px',
      '&::placeholder': {
        color: '#707070',
        textAlign: 'center',

        fontSize: '14px',
      },
    },
    '& textArea': {
      textAlign: 'left',
      color: '#753CBE',
      fontFamily: 'dana-bold',
      fontSize: '14px',

      direction: 'ltr',
      '&::placeholder': {
        color: '#707070',
        textAlign: 'center',

        fontSize: '14px',
      },
    },
  },

  provinceStyle: {
    width: '100%',
    marginTop: '20px',
    '& input': {
      width: '100%',
      height: '48px',
      borderRadius: '16px !important',
      border: 'solid 1px #ffffff',
      boxShadow:
        '8px -8px 20px 0 #ffffff, 8px 8px 20px 0 rgba(172, 172, 172, 0.5)',
      backgroundColor: '#f5f5f5',
      color: '#753cbe !important',

      fontSize: '16px !important',
      outline: 'none',
      fontWeight: '600',
      textAlign: 'center',
      '&::placeholder': {
        color: '#707070',
        fontWeight: '400',
      },
    },
  },
  noItem: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#707070',
  },
  arrowStyle: {
    padding: '8px',
    display: 'grid',
    placeItems: 'center',
  },
  textFieldMarker: {
    position: 'absolute',
    margin: 'auto',
    width: '48px',
    marginLeft: '20px',
    fontSize: '14px',
    paddingTop: '14px',
    color: 'rgba(112, 112, 112, 1)',
    zIndex: 2,
  },
  parentTextField: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'left',
  },
};

export default InputStyles;
